type QueryValue = string | number | boolean | null | undefined;
type QueryParams = Record<string, QueryValue | QueryValue[]>;

// URLSearchParams는 공백을 '+'로 인코딩하지만, qs는 RFC 3986 방식인 %20으로 인코딩한다.
// 서버 호환성을 위해 '+'를 '%20'으로 치환한다.
function encodeAsRfc3986(urlSearchParams: URLSearchParams): string {
  return urlSearchParams.toString().replace(/\+/g, '%20');
}

// qs.stringify를 대체하는 유틸 함수.
// URLSearchParams 기반으로 동작하며, 배열은 repeat 포맷(key=a&key=b)으로 직렬화한다.
export function stringifyQuery(params: QueryParams, options?: {addQueryPrefix?: boolean}): string {
  const urlSearchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    // null, undefined 값은 쿼리스트링에 포함하지 않는다.
    if (value === undefined || value === null) {
      continue;
    }

    if (Array.isArray(value)) {
      // 배열은 같은 키로 여러 번 append해 repeat 포맷으로 직렬화한다. (예: color=red&color=blue)
      value.forEach(item => {
        if (item !== undefined && item !== null) {
          urlSearchParams.append(key, String(item));
        }
      });
    } else {
      urlSearchParams.set(key, String(value));
    }
  }

  const result = encodeAsRfc3986(urlSearchParams);
  if (!result) {
    return '';
  }

  // addQueryPrefix 옵션이 true이면 '?'를 앞에 붙인다.
  return options?.addQueryPrefix ? `?${result}` : result;
}
